module.exports = __webpack_public_path__ + "img/universal-access-solid.e34fc86f.svg";